import { UserAbility } from "modules/user/config/permissions/Can";

export const ability: Partial<UserAbility> = {
  idea: {
    read: ["all"],
    create: ["all"],
    update: ["master", "program_manager", "administrator", "staff", "client"],
    delete: ["master", "program_manager", "administrator", "staff", "client"],
    config: ["master", "program_manager"]
  }
};
